module.exports = new __parcel__URL__("calendar-embed-app-skeleton.tpl.29c9a641.svg").toString();